import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withComponentId } from '../../../common/ComponentIdContext';
import { withComponentName } from '../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import { syncComponentSelector } from '../../../helpers/Common';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import { REDUCER_NAME } from '../reducer';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import STTable from './../../../common/mixTable/STTable';
import Const from './Const';

const getDataFromRedux = state => state[REDUCER_NAME].alertHistoryById;

class AlertHistoryTable extends React.PureComponent {
  onRowClick = id => {
    const {
      alertHistoryById,
      listOrganizationByOrganCode,
      syncType,
      componentId,
    } = this.props;
    const alert = alertHistoryById[id];
    if (syncType === TYPE_DISABLE || !alert.organCode) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: listOrganizationByOrganCode[alert.organCode],
      componentId,
    });
  };

  render() {
    const {
      isLoading,
      alertHistoryIds,
      handleScroll,
      resetScrollIndex,
    } = this.props;

    return (
      <STTable
        onRowClick={this.onRowClick}
        resetScrollIndex={resetScrollIndex}
        ids={alertHistoryIds}
        isLoading={isLoading}
        getDataFromRedux={getDataFromRedux}
        handleScroll={handleScroll}
        schemaKey="alertSystem.alertSystemHeader"
        listColumn={Const.listColumn}
      />
    );
  }
}

AlertHistoryTable.propTypes = {
  alertHistoryIds: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, { componentName, componentId }) => ({
  alertHistoryIds: state[REDUCER_NAME].alertHistoryIds,
  alertHistoryById: state[REDUCER_NAME].alertHistoryById,
  isLoading: state[REDUCER_NAME].isLoadingAlertHistory,
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
  syncType: syncComponentSelector(state, componentName, componentId),
});

export default compose(
  withComponentId,
  withComponentName,
  connect(mapStateToProps),
)(AlertHistoryTable);
